<template>
  <b-sidebar
    id="add-snapshot-sidebar"
    :visible="isSnapShotSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="$emit('clicked',false);"
    @change="(val) => $emit('one')"
  >
    <template>
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          SnapShot
        </h5>
      </div>
      <div class=" align-items-center  px-2 py-1">
        <div v-if="picture" class="text-center mb-2">
          <img :src="picture" style="max-width: 100%;" />
        </div>
        <v-easy-camera
            v-model="picture"
            ref="cam"
            v-if="image_upload === false"
            :startOnMounted="startOnMounted"
            :autoDetectMobile="startOnMounted"
            class="mb-5"
          />

          <b-button
            variant="primary"
            @click="capture()"
            size="lg"
            style="padding:4rem 2rem"
            block
          >
          Capture 
        </b-button>
      <b-button
        variant="danger"
        @click="upload()"
        block
        class="my-2"
        v-if="picture != null">
      Upload
    </b-button>
        <hr class="my-2"/>
           <b-form-file
           class=""
        id="wildcard"
        @change="onFileSelected"
        accept="image/*"
      />
        <b-button
          variant="outline-primary"
          @click="switch_cam()"
          block
          v-if="image_upload === false"
           class="my-2"
        >
        Switch Camera
      </b-button>
        <b-button
          variant="warning"
          class="my-1"
          @click="start()"
          block
        >
        Start Camera
      </b-button>



      <!--<img :src="picture" style="max-width:100%"> -->
    </div>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BModal, VBModal, BFormFile
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import flatPickr from 'vue-flatpickr-component'
import { ref } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'
import EasyCamera from 'easy-vue-camera'
export default {
  components: {
    ToastificationContent,
    flatPickr,
    BSidebar,
    BForm,
    BFormFile,
    BFormGroup,
     'v-easy-camera': EasyCamera,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    BModal, VBModal,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
    'b-modal': VBModal,
  },

  props: {
    isSnapShotSidebarActive: {
      type: Boolean,
      required: true,
    },
    userType: {
      type : String,
      required: true,
    },
    userData: {
      type: Object,
      required: true,
    },
  },
  computed: {

  },
  data() {
    return {
      capturing: false,
      picture:null,
      startOnMounted:false,
      image_upload: false
    }
  },
  created() {
  },
  methods: {
      onFileSelected(event) {
      const file = event.target.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.picture = e.target.result // base64 string
          this.image_upload = true
        }
        reader.readAsDataURL(file)
      }
    },
    capture() {
      this.$refs.cam.snap()
    },
    switch_cam() {
      this.$refs.cam.switchCamera()
    },
    start() {
      this.$refs.cam.start()
    //  this.$refs.cam.start()
    },
    upload() {
      let data = {
        type:this.userType,
        base64: this.picture,
        token: this.userData.token
      }
      this.$http.post(process.env.VUE_APP_API_BASE+'/staff/'+this.userData.uuid+'/snapshot/', data)
        .then(res => {
          if (res.data.result === true) {
            this.$emit('clicked', false)
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
